import * as React from 'react';
import './LoginRestriction.css';

interface LoginRestrictionProps {
    header: string;
    text: string;
}

export const LoginRestriction: React.SFC<LoginRestrictionProps> = ({ header, text }) => (
    <div className="container">
        <div className="login-restriction-panel">
            <div className="login-restriction-content">
                <h2>{header}</h2>
                <h4>{text}</h4>
            </div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/loginrestriction/LoginRestriction.tsx